<template>
    <div id="app">
        <index v-if="indexType">
            <template v-slot:content="{ navList }">
                <keep-alive :include="tagsList">
                    <router-view :navList="navList"></router-view>
                </keep-alive>
            </template>
        </index>
        <router-view v-else></router-view>
        <div class="sound">
            <audio ref="ringSuccess" :src="sound.ringSuccess"></audio>
            <audio ref="ringError" :src="sound.ringError"></audio>
        </div>
    </div>
</template>
<script>
import ringSuccess from '@/assets/wav/PASS.mp3'
import ringError from '@/assets/wav/FAIL.mp3'
import index from '@/components/index/index'
import store from '@/store'

export default {
    name: 'App',
    components: {
        index
    },
    computed: {
        route () {
            return this.$route
        }
    },
    watch: {
        route (newVal, oldVal) {
            let arr = []
            for (let item of this.$store.getters['etao/pages']) {
                if (item.route === newVal.path) {
                    // todo 会导致 nav 变成 code，不知道有什么用，先注释
                    // item.name = newVal.matched[0].components.default.name
                }

                const paths = item.path.split('/')
                arr.push(paths[paths.length - 1])
            }
            this.tagsList = arr
            this.routeDecide()
        }
    },
    methods: {
        routeDecide () {
            const route = this.$route
            this.indexType = ['login', 'oauth-callback'].indexOf(route.name) < 0
        }
    },
    data () {
        return {
            indexType: false,
            sound: {
                ringSuccess: ringSuccess,
                ringError: ringError
            },
            tagsList: []
        }
    },
    mounted () {
        this.routeDecide()
        window.playSound = (status = true) => {
            let audio = this.$refs.ringError
            if (status) {
                audio = this.$refs.ringSuccess
            }
            audio.play()
        }
        store.dispatch('i18nProp/getI18nProp')
    }
}
</script>

<style>
* {
    font-size: 14px;
    box-sizing: border-box;
    font-family: 'Harmony', Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-overflow: initial !important;
}

html, body {
    margin: 0;
    overflow: hidden;
}

#app {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: relative;
    z-index: 0;
}

.el-notification {
    z-index: 19940620 !important;
}

.el-notification__content {
    word-break: break-all;
    word-wrap: break-word;
}
.qrcode {
    position: absolute;
    right: 15%;
    background-color: #f9f9f9;
    padding: 10px;
    border: 1px solid #ccc;
    z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue